import { EventType, MatrixEvent, MatrixEventEvent } from "matrix-js-sdk";

export class Reaction {
    emoji: string;

    get count() {
        return this.events.length;
    }

    get senders() {
        return this.events.map(e => e.sender);
    }

    constructor(public events: Array<MatrixEvent>) {
        this.addListeners(events);
        this.emoji = events[0]!.event.content!['m.relates_to']!.key!;
    }

    addEvent(events: MatrixEvent | Array<MatrixEvent>) {
        if (!Array.isArray(events)) events = [events];
        this.addListeners(events);
        this.events = this.events.concat(events);
    }

    private addListeners(events: Array<MatrixEvent>) {
        for (let ev of events) {
            ev.on(MatrixEventEvent.BeforeRedaction, (ev) => {
                this.events.splice(this.events.indexOf(ev), 1);
            })
        }
    }

    getUserReaction(userId: string | null) {
        if (!userId) return undefined;
        return this.events.find(e => e.sender?.userId == userId);
    }

    includesUserReaction(userId: string | null) {
        if (!userId) return false;
        return this.events.filter(e => e.sender?.userId == userId).length > 0;
    }
}